import PropTypes from "prop-types";
import React, { useEffect } from 'react';
import { useFormContext, useWatch } from "react-hook-form";
import "./radioButtonCustomBlend.scss";

const RadioButtonCustomBlendInput = ({ key, name, defaultWeight, isDisabled, sendDataToParent }) => {
  const { register, control, formState:{errors}, getValues } = useFormContext();
  const currentValue = useWatch({
    control,
    name,
  });

  useEffect(() => {
    const allFormValues = getValues();
    sendDataToParent(allFormValues);
  }, [currentValue]);

  const validateVal = (value) => {
    if(isNaN(value)) {
      return "Please enter a valid number";
    }
    if(value > 0 && value < 10) {
      return "Weight has to be a minimum of 10% or 0%";
    }
    if(value < 0) {
      return "Weight cannot be 0%";
    }
    if(value > 100) {
      return "Weight cannot be more than 100%";
    }
    if(value % 5 !== 0) {
      return "Weight has to be in 5s";
    }
    return true;
  };

  return <>
    <input key={key} type="number" {
      ...register(name, {
          trnsformValue: (value) => parseFloat(value),
          defaultValue: 0,
          validate: validateVal
        } 
      )} readOnly={isDisabled} className="input-cust-blend" defaultValue={(defaultWeight) ? defaultWeight : ""} type="text" name={name} label={name} />
  </>
};

RadioButtonCustomBlendInput.propTypes = {
  key: PropTypes.string, 
  name: PropTypes.string,
  defaultWeight: PropTypes.number,
  isDisabled: PropTypes.bool
};

export default RadioButtonCustomBlendInput;